import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import { trans } from '../../../localization/language';
import * as facebookActions from '../../../actions/facebook';
import FacebookUser from './FacebookUser'

class ProceedFacebookConnect extends React.Component{

	handleProceed(){
		this.props.proceedFacebookConnect(this.props.fb_account.fb_token);
	}

	componentWillMount(){
		let hash = this.props.location.hash.substr(1);
		let tokens = hash.split('&')
			.map(e => e.split('='))
			.reduce((pre, cur) => { pre[cur[0]] = cur[1]; return pre}, {});

		let token = tokens['access_token'];
		let code = this.props.location.query['code'];
		if(token !== undefined || code !== undefined) {
			this.props.initFacebookConnect(token, code);
		}
	}

	render(){
		if(this.props.fb_account === undefined) {
			return null;
		}
		return (
			<div className="content">
				<div className="content-item content-item-ipage">
					<div className="content-item__title">
						{trans('confirm_connect_facebook_title')}
					</div>
					<div className="content-item--ipage__main">
						<div className="content__sendinfo">
							{trans('confirm_connect_facebook')}
						</div>
						<div className="content__form">
							<FacebookUser fb_uid={this.props.fb_account.fb_uid} fb_username={this.props.fb_account.fb_username}/>
							<div className="content__submit-wrap">
								<button className="content__submit" onClick={this.handleProceed.bind(this)}>{trans('confirm_btn')}</button>
							</div>
						</div>
					</div>
				</div>
			</div>
		)
	}
}

function mapStateToProps(state){
	return {
		fb_account: state.facebook.fb_account
	}
}

function mapDispatchToProps(dispatch){
	return bindActionCreators(Object.assign({}, facebookActions), dispatch)
}

export default connect(mapStateToProps, mapDispatchToProps)(ProceedFacebookConnect);



// WEBPACK FOOTER //
// ./app/components/security/facebook/ProceedFacebookConnect.js